import React, { useEffect, useState, useRef } from "react";

const MusicPopup = ({ showPopup }) => {
  const [show, setShow] = useState(showPopup ?? true);
  const [muted, setMuted] = useState(true);
  const audioRef = useRef(null);

  // Play/pause safely
  const toggleAudio = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (audio.paused) {
      audio.play().catch((err) => console.log("Playback prevented:", err));
      setMuted(false);
    } else {
      audio.pause();
      setMuted(true);
    }
  };

  const handleAccept = () => {
    const audio = audioRef.current;
    if (!audio) return;

    audio.play().catch((err) => console.log("Playback prevented:", err));
    setShow(false);
    setMuted(false);
  };

  const handleDecline = () => {
    setShow(false);
  };

  return (
    <>
      {show && (
        <div id="musicPopup" className="popup-overlay open">
          <div className="popup-container">
            <h2>Elevate Your Experience</h2>
            <p>
              Would you like to activate ambient music to elevate your immersive experience?
            </p>
            <div className="popup-actions">
              <button id="acceptBtn" className="btn" onClick={handleAccept}>
                Yes, Play Music
              </button>
              <button id="declineBtn" className="btn" onClick={handleDecline}>
                No, Thanks
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Fixed bottom-right mute button */}
      <button className="mute-btn" onClick={toggleAudio}>
        {muted ? <i className="fas fa-volume-mute"></i> : <i className="fas fa-volume-up"></i>}
      </button>

      <audio ref={audioRef} style={{ display: "none" }} loop>
        <source
          src="https://www.thedesignshowroom.com/assets/front_assets/images/waterfall-140894.mp3"
          type="audio/mp3"
        />
        Your browser does not support the audio element.
      </audio>
    </>
  );
};

export default MusicPopup;
